import { useState, useEffect } from 'react'
import { TextField, Box, Typography, Grid } from '@mui/material'

function DietaryAndAllergies ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.specialDietaryNeeds && formData.specialDietaryNeeds !== '-') {
      newErrors.specialDietaryNeeds = "Put '-' if no requirements, preferences or food allergies"
    }
    if (!formData.drugAllergies && formData.drugAllergies !== '-') {
      newErrors.drugAllergies = "Put '-' if no drug allergies"
    }
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Dietary & Allergies</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            label='Special Dietary Requirements / Preferences / Food Allergies'
            name='specialDietaryNeeds'
            variant='outlined'
            fullWidth
            value={formData.specialDietaryNeeds || ''}
            onChange={handleChange}
            helperText={showErrors && errors.specialDietaryNeeds ? errors.specialDietaryNeeds : 'Put "-" if no requirements, preferences or food allergies'}
            error={showErrors && !!errors.specialDietaryNeeds}
            required
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            label='Drug Allergies'
            name='drugAllergies'
            variant='outlined'
            fullWidth
            value={formData.drugAllergies || ''}
            onChange={handleChange}
            helperText={showErrors && errors.drugAllergies ? errors.drugAllergies : 'Put "-" if no drug allergies'}
            error={showErrors && !!errors.drugAllergies}
            required
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default DietaryAndAllergies
